import { FILTERS_SET_ORDER_TYPE_TYPE } from '../../constants/actionTypes';
import { EOrderField } from '../../repositories/favorites/entities/get_favorites_for_desktop/GetFavoritesForDesktopRequestSchema';
import { TReduxActions } from '../../types/redux';

const defaultDealType = EOrderField.Added;

export function orderFieldReducer(state: EOrderField = defaultDealType, action: TReduxActions) {
  switch (action.type) {
    case FILTERS_SET_ORDER_TYPE_TYPE:
      return action.orderField;
  }

  return state;
}
